import React, { useState, useEffect, useContext } from 'react';
import { getQuestions, deleteQuestion, getQuestionById } from '../api/api';
import QuestionForm from '../components/QuestionForm';
import { AuthContext } from '../context/AuthContext';
import '../index.css';
import './Users.css'; // Reuse Users CSS
import Table from '../components/common/Table';
import Header from '../components/common/Header';
import Search from '../components/common/Search';
import Button from '../components/common/Button';
import Error from '../components/common/Error';

const Questions = () => {
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [questionToEdit, setQuestionToEdit] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const { userRole } = useContext(AuthContext);

    const canCreate = userRole === "Director";
    const canUpdate = userRole === "Director";
    const canDelete = userRole === "Director";
    const canRead = userRole === "Director" || userRole === "Navegador" || userRole === "Lector";

    useEffect(() => {
        const fetchQuestions = async () => {
            setLoading(true);
            try {
                const questionsData = await getQuestions();
                setQuestions(questionsData);
            } catch (err) {
                setError(err.message || 'Error al cargar las preguntas');
            } finally {
                setLoading(false);
            }
        };
        if (canRead) {
            fetchQuestions();
        } else {
            setError("No tienes permisos para ver las preguntas")
        }
    }, [canRead, userRole]);

    const handleCreate = () => {
        setQuestionToEdit(null);
        setShowForm(true);
    };

    const handleEdit = async (id) => {
        try {
            const question = await getQuestionById(id);
            setQuestionToEdit(question);
            setShowForm(true);
        } catch (error) {
            setError(error.message || 'Error al cargar la pregunta');
        }
    };

    const handleDelete = async (id) => {
        try {
            await deleteQuestion(id);
            setQuestions(questions.filter(question => question.id !== id));
        } catch (err) {
            setError(err.message || 'Error al eliminar la pregunta');
        }
    };

    const handleCloseForm = () => {
        setShowForm(false);
        setQuestionToEdit(null);
    }

    const handleQuestionUpdated = (newQuestion) => {
        setQuestions(questions.map((question) => (question.id === newQuestion.id ? newQuestion : question)))
    }

    const handleQuestionCreated = (newQuestion) => {
        setQuestions([...questions, newQuestion])
    }

    const filteredQuestions = questions.filter((question) => {
        const questionValues = Object.values(question).join('').toLowerCase();
        return questionValues.includes(searchTerm.toLowerCase());
    });

    if (loading) return <div>Cargando...</div>;
    if (error) return <Error error={error} />;

    const tableHeaders = ["Pregunta", "Acciones"];

    const truncateText = (text, maxLength) => {
        if (!text) return "";
        if (text.length > maxLength) {
            return text.substring(0, maxLength) + "...";
        }
        return text;
    };

    const renderQuestionRow = (question) => [
        truncateText(question.question, 30),
        [
            canUpdate && <Button onClick={() => handleEdit(question.id)}>Editar</Button>,
            canDelete && <Button onClick={() => handleDelete(question.id)}>Eliminar</Button>
        ]
    ];

    return (
        <div className='container'>
            <Header title="Gestión de Preguntas" />
            <Search searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
            {canCreate && <Button onClick={handleCreate}>Crear Pregunta</Button>}
            {showForm && <div className='container-form'><QuestionForm onClose={handleCloseForm} question={questionToEdit} onQuestionUpdated={handleQuestionUpdated} onQuestionCreated={handleQuestionCreated} /></div>}
            <Table headers={tableHeaders} data={filteredQuestions} renderRow={renderQuestionRow} />
        </div>
    );
};

export default Questions;
